import { Component, ElementRef, ViewChild, AfterViewInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { DialogService } from '@app/services/dialog.service';
import { Router } from '@angular/router';
import { AuthServiceService } from '@app/services/auth-service.service';
import { ToastService } from '@app/services/toast.service';
import { ShareddtaService } from '@app/services/shareddta.service';
import { BreadcrumbService } from '@app/services/breadcrumb.service';

interface TicketFormData {
  subject: string;
  description: string;
  attachments: File[];
}

@Component({
  selector: 'app-beta-feedback',
  templateUrl: './beta-feedback.component.html',
  styleUrl: './beta-feedback.component.scss'
})
export class BetaFeedbackComponent implements AfterViewInit {
  ticketForm: TicketFormData = {
    subject: '',
    description: '',
    attachments: []
  };

  errors: { [key: string]: string } = {};

  subjectCounter = '0/100';
  descriptionCounter = '0/500';

  uploadedFiles: File[] = [];
  uploadedPreviews: string[] = [];
  MAX_FILES = 5;
  isSubmitting = false;

  constructor(private dialogService: DialogService, private router: Router, private authService: AuthServiceService, private toast: ToastService, private sharedData: ShareddtaService, private breadcrumbService: BreadcrumbService) { }

  ngAfterViewInit(): void {
    this.sharedData.signalPageReady();
  }

  ngOnInit(): void {
    this.breadcrumbService.clear();
  }

  goToDashboard(): void {
    const isReceiving = this.router.url.startsWith('/receiving-admin');
    this.router.navigate([isReceiving ? '/receiving-admin/orders' : '/admin/dashboard']);
  }

  updateSubjectCount(): void {
    const length = this.ticketForm.subject.length;
    this.subjectCounter = length + '/100';
  }

  updateDescriptionCount(): void {
    const length = this.ticketForm.description.length;
    this.descriptionCounter = length + '/500';
    this.validateForm()
  }

  onFileSelect(event: any): void {
    const files = Array.from(event.target.files) as File[];
    // uncumment below line
    if (this.uploadedFiles.length + files.length > this.MAX_FILES) {
      this.toast.show('error', `You can only upload maximum ${this.MAX_FILES} images`);
      return;
    }

    files.forEach(file => {
      if (file.type.startsWith('image/')) {
        this.uploadedFiles.push(file);
        this.displayImage(file);
      }
    });

    event.target.value = '';
  }

  displayImage(file: File): void {
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.uploadedPreviews.push(e.target.result);
    };
    reader.readAsDataURL(file);
  }

  removeImage(index: number): void {
    this.uploadedFiles.splice(index, 1);
    this.uploadedPreviews.splice(index, 1);
  }

  openFileSelector(): void {
    const fileInput = document.getElementById('fileInput') as HTMLInputElement;
    if (fileInput) {
      fileInput.click();
    }
  }

  validateForm(): boolean {
    this.errors = {};
    let isValid = true;

    //  if (!this.ticketForm.subject.trim()) {
    //    this.errors['subject'] = 'Subject is required';
    //    isValid = false;
    //  }

    if (!this.ticketForm.description.trim()) {
      this.errors['description'] = 'Feedback is required.';
      isValid = false;
    }

    return isValid;
  }

  //  createTicket(): void {
  //    if (!this.validateForm()) {
  //      return;
  //    }

  //    console.log('Ticket data:', {
  //      subject: this.ticketForm.subject,
  //      description: this.ticketForm.description,
  //      attachments: this.uploadedFiles.length
  //    });

  //    alert('Ticket created successfully!');

  //    // Here you would typically call your API service
  //    // this.ticketService.createTicket(this.ticketForm).subscribe(...)
  //  }

  //  cancel(): void {
  //    if (confirm('Are you sure you want to cancel? Any unsaved changes will be lost.')) {
  //      this.resetForm();
  //    }
  //  }
  createTicket(): void {

    if (!this.validateForm()) {
      return;
    }

    this.isSubmitting = true;

    const formData = new FormData();

    // API ke hisab se
    formData.append('text', this.ticketForm.description);

    const imagePromises: Promise<void>[] = [];

    for (let i = 0; i < this.uploadedFiles.length; i++) {
      formData.append('attachment', this.uploadedFiles[i]);
    }

    Promise.all(imagePromises)
      .then(() => {

        this.authService.feeBackAdd(formData).subscribe(
          (data: any) => {
            this.isSubmitting = false;

            if (this.authService.resultCodeError(data)) {
              return;
            }
            this.toast.show('success', data.status);
            this.uploadedFiles = [];
            this.ticketForm.subject = '';
            this.ticketForm.description = '';
            this.resetForm();

          },
          (error) => {
            this.isSubmitting = false;
            this.authService.dataError(error);
          }
        );

      })
      .catch((error) => {
        this.isSubmitting = false;
        console.error('Error converting images:', error);
      });
  }

  hasChanges(): boolean {
    return this.ticketForm.description.trim().length > 0 ||
           this.ticketForm.subject.trim().length > 0 ||
           this.uploadedFiles.length > 0;
  }

  async cancel(): Promise<void> {
    if (!this.hasChanges()) {
      window.history.back();
      return;
    }

    const confirmed = await this.dialogService.confirm(
      'Discard Changes',
      'Are you sure you want to cancel? Any unsaved changes will be lost.'
    );

    if (confirmed.confirmed) {
      window.history.back();
    }
  }


  resetForm(): void {
    this.ticketForm = {
      subject: '',
      description: '',
      attachments: []
    };
    this.uploadedFiles = [];
    this.uploadedPreviews = [];
    this.errors = {};
    this.updateSubjectCount();
    this.updateDescriptionCount();
  }

  goBack(): void {
    window.history.back();
  }
}